import { settingSlice } from "./reducers";
import axios from "axios";
import url from "../../configs/config";
import { jwtDecode } from "jwt-decode";
import { roleTypes } from "../../data/roleType";

const getRedirectPath = (decodedToken) => {
  const isSuperAdmin = decodedToken?.user?.roles?.some(
    (role) => role.role_type === roleTypes.SUPER_ADMIN
  );
  return `/${isSuperAdmin ? "admin" : "user"}/auth/sign-in`;
};

const handleLogoutAndRedirect = (decodedToken = null) => {
  localStorage.removeItem("coyote-token");
  const redirectPath = decodedToken
    ? getRedirectPath(decodedToken)
    : "/user/auth/sign-in";
  window.location.href = redirectPath;
};

export const fetchPermissionsData = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("coyote-token");

    if (!token || typeof token !== "string" || token.trim() === "") {
      console.error("JWT token is missing or invalid");
      return;
    }

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch (error) {
      console.error("Error decoding token:", error);
      handleLogoutAndRedirect();
      return;
    }

    if (!decoded?.user?.roles?.some((role) => role.role_type)) {
      console.error("Invalid user roles in token");
      handleLogoutAndRedirect(decoded);
      return;
    }

    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    if (
      decoded.user?.roles?.some(
        (role) => role.role_type !== roleTypes.SUPER_ADMIN
      )
    ) {
      const response = await axios.get(
        `${url.backendURL}user/warehouse-permissions`,
        config
      );

      const permissions = response?.data?.response?.data;
      if (permissions) {
        dispatch(
          settingSlice.actions.set_permissions({
            permissions,
          })
        );
      } else {
        dispatch(settingSlice.actions.set_permissions({}));
      }
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error;

    if (
      errorMessage === "jwt expired" ||
      errorMessage === "Unauthorized. User not found"
    ) {
      let decoded = null;
      try {
        const token = localStorage.getItem("coyote-token");
        if (token) {
          decoded = jwtDecode(token);
        }
      } catch (e) {}

      handleLogoutAndRedirect(decoded);
    } else {
      console.error("Failed to fetch permissions data:", error);
    }
  }
};

export const fetchRolesData = () => async (dispatch) => {
  try {
    const config = {
      headers: {},
    };

    const response = await axios.get(`${url.backendURL}user/roles`, config);
    const roles = response?.data?.response?.data;

    if (roles) {
      dispatch(settingSlice.actions.set_roles({ roles }));
    } else {
      dispatch(settingSlice.actions.set_roles([]));
    }
  } catch (error) {
    console.error("Failed to fetch roles data:", error);
  }
};

export const {
  reset_state,
  app_name,
  theme_scheme_direction,
  theme_scheme,
  theme_style_appearance,
  theme_color,
  theme_transition,
  theme_font_size,
  page_layout,
  header_navbar,
  card_style,
  header_banner,
  sidebar_color,
  sidebar_type,
  sidebar_show,
  navbar_show,
  sidebar_menu_style,
  footer,
  body_font_family,
  heading_font_family,
  setSetting,
  set_permissions,
  set_roles,
} = settingSlice.actions;

export default settingSlice.actions;
